// Fallback data for RG Fodpleje
// Dette sikrer at siden altid virker og indlæser lynhurtigt, selv hvis der er netværksforsinkelse på CMS API'et.

export const virksomhedsinfo = {
  navn: "RG Fodpleje",
  telefon: "29 90 29 66",
  email: "lrgertsen@mail.dk",
  adresse: "Søhusvænget 25, 5270 Odense N",
  instagram: "https://www.instagram.com/rg_fodpleje/",
  facebook: "https://www.facebook.com/profile.php?id=61575333505129",
  logo: "https://assets.auxodev.dk/assets/fc34e8db-fc4d-4e5c-ac32-f5583f3c3cfe/3b2376f7-8de5-47ea-a4e7-a708600a8d65.jpg"
};

export const fallbackPages = [
  {
    page_slug: "index",
    title: "Forside",
    meta_title: "RG Fodpleje - Professionel fodpleje i Odense N",
    meta_description: "Professionel fodpleje i Odense N hos RG Fodpleje med fokus på kvalitet, ro, nærvær, sundhed og velvære. Book din tid i dag.",
    content: "<p>Hos RG Fodpleje er der fokus på kvalitet, ro og nærvær. Her bliver du mødt med god tid.</p><p>Hver fodbehandling udføres grundigt og professionelt, med opmærksomhed på både velvære og sundhed.</p>",
    images: ["https://assets.auxodev.dk/assets/fc34e8db-fc4d-4e5c-ac32-f5583f3c3cfe/6ff38804-473d-4647-91a8-2151bb31a68d.JPEG"]
  },
  {
    page_slug: "om-mig",
    title: "Om mig",
    meta_title: "Om mig - RG Fodpleje",
    meta_description: "Læs mere om Rikke og klinikken RG Fodpleje i Odense N. Professionel fodpleje i trygge hænder med høj hygiejnestandard.",
    content: "<p>Hos RG Fodpleje er dine fødder i trygge hænder. Med fokus på både velvære og sundhed tilbyder jeg professionel fodpleje i rolige og hyggelige omgivelser. Uanset om du døjer med hård hud, ligtorne, negleproblemer, fodvorter eller blot ønsker en afslappende behandling, skræddersyr jeg den rette løsning til dig. Behandlingerne foregår med grundighed, omtanke og høj hygiejnestandard – altid med udgangspunkt i dine behov. Jeg er uddannet fodplejer og brænder for at give dig den bedste oplevelse og mærkbar forskel, du kan gå ud ad døren med. Forkæl dine fødder – de bærer dig trods alt gennem livet!</p><p>Jeg er medlem af SADF - Sammenslutningen Af Dansk Fodplejere, som er en brancheorganisation for professionelle fodplejere. SADF sikrer at RG Fodpleje lever op til gældende regler vedr. fx hygiejne. Alt værktøj steriliseres i en autoklave, når det har været i brug, og opbevares i forseglede poser indtil det skal i brug igen.</p>",
    images: ["https://assets.auxodev.dk/assets/fc34e8db-fc4d-4e5c-ac32-f5583f3c3cfe/1b0e52f5-3c4b-4fbb-8990-a60b7cc063da.JPEG"]
  },
  {
    page_slug: "behandlinger",
    title: "Behandlinger",
    meta_title: "Behandlinger & Priser - RG Fodpleje",
    meta_description: "Se priser og beskrivelser af vores professionelle fodbehandlinger hos RG Fodpleje i Odense N. Fodbehandling, ligtorne og fodvorter.",
    content: "<p>Se vores udvalg af behandlinger nedenfor, og book en tid til din næste behandling.</p>",
    images: ["https://assets.auxodev.dk/assets/fc34e8db-fc4d-4e5c-ac32-f5583f3c3cfe/behandling-af-fodvorte.jpeg"]
  },
  {
    page_slug: "kontakt",
    title: "Kontakt",
    meta_title: "Kontakt - RG Fodpleje",
    meta_description: "Kontakt RG Fodpleje i Odense N. Ring på 29 90 29 66, send en mail eller besøg klinikken på Søhusvænget 25. Book tid online.",
    content: "<p>Ønsker du at komme i kontakt med mig, kan det gøres på nedestående informationer</p><p>Telefonnummer: 29 90 29 66<br/>Email: lrgertsen@mail.dk<br/>Adresse: Søhusvænget 25, 5270 Odense N</p>",
    images: ["https://assets.auxodev.dk/assets/fc34e8db-fc4d-4e5c-ac32-f5583f3c3cfe/1b0e52f5-3c4b-4fbb-8990-a60b7cc063da.JPEG"]
  },
  {
    page_slug: "behandling-af-ligtorn",
    title: "Behandling af ligtorn i Odense med grundig fodpleje",
    meta_title: "Behandling af ligtorn i Odense | Fjern ligtorn fra 260kr.",
    meta_description: "Få målrettet behandling af ligtorn i Odense hos RG Fodpleje. Samme behandler hver gang, grundig beskæring og hulbor. Book nemt online i dag.",
    content: "<p>En ligtorn kan gøre det ubehageligt at gå, stå og bruge dine sædvanlige sko. Hos RG Fodpleje får du målrettet behandling af ligtorn i Odense, hvor den hårde hud beskæres, og der arbejdes med hulbor i dybden. Du møder altid den samme behandler i klinikken.</p>",
    images: ["https://assets.auxodev.dk/assets/fc34e8db-fc4d-4e5c-ac32-f5583f3c3cfe/behandling-af-ligtorn.png"]
  }
];

export const fallbackBehandlinger = [
  {
    treatment_slug: "fodbehandling",
    title: "Fodbehandling",
    price: 400,
    description: "<p>Behandlingen starter med blødgørende fodbad.</p><p>Tåneglene klippes, slibes, renses evt. nedgroede negle ordnes.</p><p>Hård hud beskæres og slibes evt. ligtorne fjernes.</p><p>behandlingen sluttes af med negleolie og en dejlig fodcreme.</p>",
    image: ["https://assets.auxodev.dk/assets/fc34e8db-fc4d-4e5c-ac32-f5583f3c3cfe/fodbehandling-odense.jpeg"]
  },
  {
    treatment_slug: "fodbehandling-med-neglelak-eller-gel",
    title: "Fodbehadling med Neglelak eller gel",
    price: 570,
    description: "<p>Behandlingen starter med et blødgørende fodbad.</p><p>tåneglene klippes, slibes og evt. nedgroede negle ordnes.</p><p>Hård hud beskæres og slibes og evt. ligtorne fjernes.</p><p>Valgfri lak eller gel.</p><p>Ingen design.</p><p><strong>HUSK at medbringe et par åbne sandaler/klipklapper til hjemturen</strong></p>",
    image: ["https://assets.auxodev.dk/assets/fc34e8db-fc4d-4e5c-ac32-f5583f3c3cfe/fodbehandling-med-neglelak.jpeg"]
  },
  {
    treatment_slug: "fodvortebehandling",
    title: "Fodvortebehandling",
    price: 260,
    description: "<p>Fodbad og beskæring af vorten og derefter behandles den med Hydrozid. Der behandles max 4 fodvorter pr. behandling.</p><p>Hydrozid er en effektiv behandling, der nedbryder forvorter og fremmer heling uden at skade det omkringliggende væv.</p><p>Det kan være nødvendigt med flere behandlinger afhængigt af vortenes størrelse og placering.</p>",
    image: ["https://assets.auxodev.dk/assets/fc34e8db-fc4d-4e5c-ac32-f5583f3c3cfe/behandling-af-fodvorte.jpeg"]
  },
  {
    treatment_slug: "behandling-af-ligtorne",
    title: "Behandling af ligtorne",
    price: 260,
    description: "<p>Ligtorne beskæres. Hulbor anvendes for at komme i dybden af ligtornen.</p>",
    image: ["https://assets.auxodev.dk/assets/fc34e8db-fc4d-4e5c-ac32-f5583f3c3cfe/behandling-af-ligtorn.png"]
  }
];

export const fallbackPriser = [
  { titel: "Fodbehandling", pris: 400, sortering: 1 },
  { titel: "Fodbehadling med Neglelak eller gel", pris: 570, sortering: 2 },
  { titel: "Fodvortebehandling", pris: 260, sortering: 3 },
  { titel: "Behandling af ligtorne", pris: 260, sortering: 4 }
];

export const videoer = [
  {
    navn: "RG Fodpleje video 5 justeret",
    url: "https://assets.auxodev.dk/assets/fc34e8db-fc4d-4e5c-ac32-f5583f3c3cfe/ddca3816-e434-4f35-83c8-ab1223422d72.mp4"
  },
  {
    navn: "RG Fodpleje video 4",
    url: "https://assets.auxodev.dk/assets/fc34e8db-fc4d-4e5c-ac32-f5583f3c3cfe/8e95166f-9222-43d2-93b4-db99e41cd679.mp4"
  },
  {
    navn: "RG Fodpleje video 3 justeret",
    url: "https://assets.auxodev.dk/assets/fc34e8db-fc4d-4e5c-ac32-f5583f3c3cfe/b5030c44-3982-4a30-9911-c07d70fff5c1.mp4"
  },
  {
    navn: "RG Fodpleje video 2",
    url: "https://assets.auxodev.dk/assets/fc34e8db-fc4d-4e5c-ac32-f5583f3c3cfe/13314559-db6f-4f6a-b968-30c2a2eefac0.mp4"
  },
  {
    navn: "RG Fodpleje video 1",
    url: "https://assets.auxodev.dk/assets/fc34e8db-fc4d-4e5c-ac32-f5583f3c3cfe/07029656-b739-4c36-a0c2-bd0262085577.mp4"
  }
];

export const galleriBilleder = [
  "https://assets.auxodev.dk/assets/fc34e8db-fc4d-4e5c-ac32-f5583f3c3cfe/fodbehandling-med-neglelak.jpeg",
  "https://assets.auxodev.dk/assets/fc34e8db-fc4d-4e5c-ac32-f5583f3c3cfe/behandling-af-fodvorte.jpeg",
  "https://assets.auxodev.dk/assets/fc34e8db-fc4d-4e5c-ac32-f5583f3c3cfe/fodbehandling-odense.jpeg",
  "https://assets.auxodev.dk/assets/fc34e8db-fc4d-4e5c-ac32-f5583f3c3cfe/1b0e52f5-3c4b-4fbb-8990-a60b7cc063da.JPEG"
];
